(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodWizardSteps', sodWizardSteps);

    function sodWizardSteps() {
        return {
            restrict: 'E',
            templateUrl: 'common/components/sod-wizard-steps',
            controller: sodWizardStepsCtrl,
            controllerAs: 'vm',
            bindToController: true,
        };
    }

    function sodWizardStepsCtrl($scope, $timeout, $injector) {
        var vm = this;

        this.$onInit = function() {
            vm.executingAPI;
            vm.submitted = false;
            vm.wizardStepActive;

            vm.handleStepClicked = handleStepClicked;

            init();
        }

        function init() {
            setWizardSetActive(0);
        }

        function setWizardSetActive(stepIndex) {
            vm.wizardStepActive = stepIndex;
        }

        function handleStepClicked(stepIndex, externalApi) {
            return function () {
                if (vm.executingAPI)
                    return;

                if (!(stepIndex === 'submit')) {
                    // if jump of the stepIndex is more than 1
                    // do not execute the steps
                    if (stepIndex - vm.wizardStepActive > 1)
                        return;

                    // allows immediate change of step if it's
                    // returning to previous steps
                    if (stepIndex < vm.wizardStepActive) {
                        setWizardSetActive(stepIndex);
                        return;
                    }
                }

                vm.executingAPI = true;
                var funcCallType = (typeof externalApi == typeof function () {
                });
                var funcCall = funcCallType ? externalApi : executeAPI;

                funcCall()
                    .then(function () {
                        setWizardSetActive(stepIndex);
                    })
                    .catch(function (res) {
                        // console.log(res);

                        switch (res.status) {
                            case 422: {
                                var FormBuilderService = $injector.get('FormBuilderService');
                                var fbService = FormBuilderService.get($scope.panel.data.options.massApply.form_id);
                                fbService.elementsService.setValidationRules(res.data.rules, res.data.summary);
                                window.dataLayer.push(
                                    {
                                        event: 'validationErrorOccurred',
                                        step: vm.wizardStepActive
                                    }
                                );
                                // // ActionManager('enable-button', data.evtData.targetScope.name);
                                break;
                            }
                        }
                        // var FormBuilderService = $injector.get('FormBuilderService');
                        // var fbService = FormBuilderService.get(data.evtData.formIdentifier);
                        // fbService.elementsService.setValidationRules(data.response.rules, data.response.summary);
                        // // ActionManager('enable-button', data.evtData.targetScope.name);
                        // ActionManager('enable-button', {
                        //     enable_all_disabled: true
                        // });
                    })
                    .finally(function () {
                        if (funcCallType) {
                            vm.executingAPI = false;
                            if (stepIndex === 'submit') {
                                vm.submitted = true;
                                window.dataLayer.push({event: 'applicationSubmit'});
                            }
                        } else {
                            $scope.$apply(function () {
                                vm.executingAPI = false;
                                if (stepIndex === 'submit') {
                                    vm.submitted = true;
                                }

                            });
                        }
                        // $scope.$apply();
                    });

            };
        }

        function handleSubmit(externalApi) {

        }

        function executeAPI() {
            return new Promise(function (resolve, reject) {
                $timeout(function () {
                    resolve();
                }, 1000);
            });
        }
    }
})();